import { InquiryState, PaymentStatus } from './index';
import { MutationTree } from 'vuex';
import Inquiry from "../interfaces/inquiry";
import DealResponse from "../interfaces/dealResponse";
import { VALID } from "@constants/voucher";

export default {
    setInquiry(state: InquiryState, inquiry: Inquiry) {
        state.inquiry = inquiry;
    },
    setDataPolicy(state: InquiryState, { value: value, checksum: __datapolicy_checksum, type: __datapolicy_type, text: text } ) {
        state.dataPolicy = {
            __datapolicy_checksum: __datapolicy_checksum,
            __datapolicy_type: __datapolicy_type,
            dataPolicyAccepted: value,
            consent: text
        };
    },
    setWhitelabelConsent(state: InquiryState, accepted: boolean) {
        state.whitelabelConsent = accepted;
    },
    setDealResponse(state: InquiryState, response: DealResponse) {
        state.dealResponse = response;
    },
    setPaymentStatus(state: InquiryState, status: PaymentStatus) {
        state.paymentStatus = status;
    },
    resetTraveller(state: InquiryState) {
        state.inquiry.travellers = [];
    },
    savePaymentMethod(state, paymentMethod: string) {
        state.inquiry.paymentMethod = paymentMethod;
    },
    setVoucherStatus(state, voucherStatus: string) {
        state.voucher.isValid = voucherStatus === VALID;
        state.voucher.isValidated = true;
    },
    setCurrentVoucher(state, currentVoucher: string) {
        state.voucher.currentVoucher = currentVoucher;
    },
    voucherValidated(state, isValidated: boolean) {
        state.voucher.isValidated = isValidated;
    },
    clearVoucher(state) {
        state.voucher.isValid = true;
        state.voucher.currentVoucher = '';
        state.voucher.isValidated = true;
    },
    setNewsletterConsent(state: InquiryState, accepted: boolean) {
        state.inquiry.consent.newsletter = accepted;
    }
} as MutationTree<InquiryState>
